import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getNestedProperty } from '../../helpers/getNestedProperty';
import { StatusInputWrapper } from '../StatusInputWrapper';

const City = ({ t, reduxAppProperty, changeObjectPropertyAction, validateCity, cityError, cityValid, setIsError }) => {
  // const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const city = useSelector((state) => getNestedProperty(state.app, reduxAppProperty).city)

  const handleCity = (e) => {
    try {
      let name = e.currentTarget.value
      changeObjectPropertyAction('city', name);
      validateCity(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurCity = (e) => {
    try {
      SetIsFocussed(false)
      let name = e.currentTarget.value.trim()
      changeObjectPropertyAction('city', name);
      validateCity(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  return (
    <StatusInputWrapper
      isValid={cityValid}
      errorMsg={cityError}
      t={t}
      label={t('current_address.city')}
      customClasses={'fw-10'}
      id="City" name="City" type="text"
      isFocussed={isFocussed}
      aria-describedby="city"
      onChange={handleCity}
      onBlur={onBlurCity}
      onFocus={() => SetIsFocussed(true)}
      value={city}
      autoComplete="off"
      maxLength="50"
    />
  )
}

export default withTranslation('common')(City)